(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-credit', {
            parent: 'entity',
            url: '/queue-credit?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_credit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-credit/queue-credits.html',
                    controller: 'Queue_creditController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_credit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-credit-detail', {
            parent: 'entity',
            url: '/queue-credit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_credit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-credit/queue-credit-detail.html',
                    controller: 'Queue_creditDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_credit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue_credit', function($stateParams, Queue_credit) {
                    return Queue_credit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-credit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-credit-detail.edit', {
            parent: 'queue-credit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-credit.new', {
            parent: 'queue-credit',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                customer_email: null,
                                credit_value: null,
                                comment: null,
                                id_queue: null,
                                campagna: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('queue-credit');
                });
            }]
        })
        .state('queue-credit.edit', {
            parent: 'queue-credit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-dialog.html',
                    controller: 'Queue_creditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-credit.delete', {
            parent: 'queue-credit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-credit/queue-credit-delete-dialog.html',
                    controller: 'Queue_creditDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue_credit', function(Queue_credit) {
                            return Queue_credit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-credit', null, { reload: 'queue-credit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
